import { render, staticRenderFns } from "./newTopicDetail.vue?vue&type=template&id=7df4cf08&scoped=true&"
import script from "./newTopicDetail.vue?vue&type=script&lang=js&"
export * from "./newTopicDetail.vue?vue&type=script&lang=js&"
import style0 from "./newTopicDetail.vue?vue&type=style&index=0&id=7df4cf08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4cf08",
  null
  
)

export default component.exports